import React from "react";
import {
  Select,
  MenuItem,
  FormHelperText,
  FormControl,
  Input,
} from "@mui/material";

import styled from "styled-components";
import { FontStyles } from "../index";
import { useFormFull } from "form-full";
import { Spacing } from "../../config";
export type TextInputAutoCompleteBaseProps = {
  label?: string;
  hideVisualError?: boolean;
  smallBottom?: number;
  alternativeColors?: boolean;
  heightInput?: number;
  inputStyle?: typeof styled;
  disabled?: boolean;
  required?: string;
  readOnly?: boolean;
  placeholder?: string;
  justNumbers?: boolean;
  options: Array<{
    label: string;
    value: string | number;
  }>;
  name: string;
  disableError?: boolean;
  white?: boolean;
  defaultValue?: any;
  containerStyles?: any;
  customInput?: any;
  $maxHeight?: any;
  onChangeCustom?: any;
  onBlurCustom?: any;
};
interface StyledInputProps {
  $inputStyle?: any;
  $error?: boolean;
  $small?: boolean;

  $minHeight?: boolean;
}
const StyledInput = styled(Input)<StyledInputProps>(
  ({
    theme,
    error,
    disabled,
    $inputStyle,
    $error,
    $small,

    $minHeight,
    ...rest
  }) => {
    return {
      padding: 0,
      "&&.MuiInput-root": {
        ...FontStyles.medium14,
        padding: theme.spacing(1),
        alignItems: $minHeight && "flex-start",
        paddingTop: $minHeight && Spacing(2),
        marginTop: Spacing(1.5),
        minHeight: $minHeight && Spacing(20),
        textOverflow: "ellipsis",
        color: error ? "red" : theme.palette.text.primary,
        backgroundColor: theme.palette.primary.contrastText,
        borderBottom: "0px",
        borderRadius: theme.spacing(0.6),
        "& .MuiInputBase-input": {
          padding: 0,
          backgroundColor: "transparent",
          boxShadow: "transparent 0px 0px !important",
        },
        ...$inputStyle,
      },
    };
  }
);
const StyledFormControl = styled(FormControl)(({ theme }) => {
  return {};
});

const StyledMenuItem = styled(MenuItem)(({ theme }) => {
  const { palette: colors } = theme;
  return {
    ...FontStyles.medium14,
    backgroundColor: "#E6EFEE",
    "&.MuiListItem-button:hover": {
      backgroundColor: "#E6EFEE20",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "transparent",
    },
    "&.Mui-selected": {
      backgroundColor: "#E6EFEE50",
    },

    "& .MuiPaper-root": {
      backgroundColor: "red",
    },
  };
});
interface StyledSelectProps {

  $withError?: boolean;

}
const StyledSelect = styled(Select)<StyledSelectProps>(({ theme, $withError, disabled }) => {
  const { palette: colors, spacing } = theme;
  return {
    ...FontStyles.medium14,
    color: colors.text.primary,
    padding: '7px',
    borderRadius: spacing(0.7),
    marginTop: spacing(1.5),
    opacity: disabled ? 0.6 : 1,
    border: $withError
      ? `1px solid ${colors.background.paper}`
      : "0px solid red",

    // FilledInput background
    "&.MuiFilledInput-root": {
      backgroundColor: "#E9E9E9",
      "&:hover": {
        backgroundColor: "#E9E9E9",
      },
      "&.Mui-focused": {
        backgroundColor: "#E9E9E9",
      },
    },
    "& .MuiSelect-select": {
      padding: "7px",
      maxHeight: "50px",
      paddingLeft: spacing(1),
      backgroundColor: "transparent",
    },
    "& .MuiSelect-icon": {
      color: "#00796D",
    },
  };
});
interface StyledpProps {

  $withError?: boolean;
  white?: boolean;
}
const Label = styled.p<StyledpProps>(({ theme, $withError, white }) => {
  const { palette: colors } = theme;
  return {
    ...FontStyles.semibold14,
    textTransform: "uppercase",
    padding: 0,
    margin: 0,
    color: $withError
      ? colors.error.main
      : white
        ? "white"
        : colors.action.selected,
    transition: ".2s",
    pointerEvents: "none",
    alignItems: "center",
    display: "flex",
    overflow: "hidden",
  };
});

function SelectComponent(props: TextInputAutoCompleteBaseProps) {
  const { value, error, onChange, onBlur, ref, ffHandler } =
    useFormFull.field(props);

  const { name, onChangeCustom } = props;
  const onSelectValue = React.useCallback(
    (event) => {
      try {
        onChange(event, event.target.value);
        onChangeCustom && onChangeCustom(event.target.value, ffHandler);
      } catch (err) { }
      setTimeout(() => {
        onBlur(event);
        ffHandler?.testFieldError(name, false);
      }, 10);
    },
    [onChange, onBlur, ffHandler, name, onChange]
  );

  const {
    containerStyles,
    label,
    customInput,
    $maxHeight,
    required,

    options,
    disableError,

    alternativeColors = false,
    disabled,
    readOnly,
    white,
    onBlurCustom,
  } = props;

  return (
    <StyledFormControl
      style={containerStyles}
      fullWidth
      error={Boolean(error)}
      required={Boolean(required)}
      onMouseUp={(event) => event.stopPropagation()}
    >
      <Label
        white={white}
        $withError={Boolean(error)}
      >
        {label}
      </Label>
      <StyledSelect variant="filled"
        white={white}
        readOnly={readOnly}
        disabled={disabled}
        required={!!required}
        $withError={Boolean(error)}
        $alternativeColors={alternativeColors}
        disableUnderline
        ref={ref}
        value={value}
        $maxHeight={$maxHeight}
        onChange={onSelectValue}
        onBlur={(e) => {
          onBlurCustom();
        }}
        onMouseUp={(event) => event.stopPropagation()}
        {...(customInput && {
          input: <StyledInput
            readOnly={readOnly}
            disabled={disabled}
          />
        })}

      >
        {options?.map((option) => (
          <StyledMenuItem value={option.value}>{option.label}</StyledMenuItem>
        ))}
      </StyledSelect>
      {disableError ? null : (
        <FormHelperText>{error ? error : " "}</FormHelperText>
      )}
    </StyledFormControl>
  );
}

export default SelectComponent;
